import React, { useState, useEffect, useMemo, useCallback } from "react";
import DataTable from "react-data-table-component";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { skillLocationAPI } from "../../api/skillm";
import { getAllCities } from "../../api/common";
import * as XLSX from "xlsx";

const LocationMatrix = () => {
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [downloading, setDownloading] = useState(false);

  const [reqParams, setReqParams] = useState({
    page: currentPage,
    limit: perPage,
  });

  const [fetch, setFetch] = useState(true);

  const fetchUsers = useCallback(
    (params) => {
      setLoading(true);
      skillLocationAPI(params)
        .then((res) => {
          setData(res?.skill_with_locations);
          setLocations(res?.locations);
          handleCreateColumns(res?.locations);
          //  setTotalRows(res?.total_record);
          setLoading(false);
          setFetch(false);
        })
        .catch((err) => {
          swal("Error", err?.message, "error");
          setLoading(false);
          setFetch(false);
        });
    },
    [setFetch]
  );

  useEffect(() => {
    if (fetch) {
      fetchUsers(reqParams);
    }
  }, [fetch, reqParams, fetchUsers]);

  const handlePageChange = useCallback(
    (page) => {
      setCurrentPage(page);
      setReqParams({
        ...reqParams,
        page: page,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handlePerRowsChange = useCallback(
    async (newPerPage, page) => {
      setPerPage(newPerPage);
      setReqParams({
        ...reqParams,
        limit: newPerPage,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handleCreateColumns = useCallback((locations) => {
    let cols = [
      {
        name: "Skills",
        selector: (row) => row.skill_title,
        width: "250px",
        wrap: true,
      },
    ];
    locations.forEach((loc) => {
      cols.push({
        name: loc,
        width: "150px",
        wrap: true,
        selector: (row) => (row[loc] ? row[loc] : 0),
      });
    });
    setColumns(cols);
  }, []);

  const downloadExcel = () => {
    setDownloading(true);
    //Prepare the data for Excel export
    const worksheetData = data.map((d) => {
      const row = { "Skill Title": d.skill_title };
      locations.forEach((location, index) => {
        row[location] = d[location] ? d[location] : 0;
      });
      return row;
    });
    //Convert to worksheet
    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    // Create a new workbook and add the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Location Matrix");
    // Save the file
    XLSX.writeFile(workbook, "LocationMatrix.xlsx");

    setDownloading(false);
  };

  return (
    <>
      <div className="d-flex justify-content-between mb-3">
        <button
          className="btn btn-primary"
          onClick={downloadExcel}
          disabled={downloading}
        >
          Download Excel
        </button>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="table-responsive">
            <DataTable
              className="table display dataTablesCard job-table table-responsive-xl card-table dataTable no-footer"
              columns={columns}
              data={data}
              progressPending={loading}
              pagination
              //paginationServer
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              persistTableHead
              //sortServer
              fixedHeader={true}
              fixedHeaderScrollHeight={"500px"}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default LocationMatrix;
